<template>
  <div class="hiddenDanger">
    <div class="pig">
      <div>隐患状态统计</div>
      <div id="dangerChat" :style="{width: '100%', height: '320px'}"></div>
    </div>
    <div class="danger_footer">
      <div id="dangerChat2" :style="{width: '100%', height: '400px'}"></div>
    </div>
  </div>
</template>

<script>
var xdata = ['未处理', "已处理", "无法修复"];
import * as echarts from 'echarts';
import axios from 'axios';
export default {
  data() {
    return {

    }
  },
  mounted() {
    this.hiddenDanger()
  },
  props: ['hiddenDangerList'],
  watch: {
    hiddenDangerList: function (newVal, oldVal) {
      console.log("hiddenDangerList")
      this.hiddenDanger()
    }
  },
  methods: {
    hiddenDanger() {
      var that = this
      var syjgdata = []
      // 基于准备好的dom，初始化echarts实例
      let myChart = that.$echarts.init(document.getElementById('dangerChat'))
      let myChart2 = that.$echarts.init(document.getElementById('dangerChat2'))
      axios.get('/api/powermis/bigScreen/getHiddenDanger').then(response => {
        //按状态统计机数
        syjgdata = [{
          "name": "未处理",
          "value": response.data.data.bigScreenHiddenDangerData.unprocessedCount
        }, {
          "name": "已处理",
          "value": response.data.data.bigScreenHiddenDangerData.processedCount
        }, {
          "name": "无法修复",
          "value": response.data.data.bigScreenHiddenDangerData.beyondRepairCount
        }]
        myChart.setOption(
          {
            legend: {
              orient: "horizontal",
              top: 10,
              x: 'center',
              // orient: "vartical",
              // left: '75%',  //图例距离左的距离
              // y: 'center',  //图例上下居中
              data: xdata,
              itemWidth: 13,
              itemHeight: 8,
              itemGap: 16,
              textStyle: {
                color: '#FFFFFF'
              },
              formatter: function (name) {
                return '' + name
              }
            },
            series: [{
              itemStyle: {
                normal: {
                  color: function (params) {
                    //渐变色列表，自定义自己需要的颜色
                    var colorLists = [
                      {
                        c1: "#21E754",
                        c2: "#FFEE5A"
                      },
                      {
                        c1: "#23A6C7",
                        c2: "#1CF185"
                      },
                      {
                        c1: "#FFDF5F",
                        c2: "#FF5959"
                      },
                    ];
                    return new that.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                        offset: 0,
                        color: colorLists[params.dataIndex].c1
                      },
                      {
                        offset: 1,
                        color: colorLists[params.dataIndex].c2
                      }
                    ]);
                  },
                  // ['rgba(63,227,236,0.3)'],
                  borderColor: '#5D6D7C',
                  borderWidth: 3
                }
              },
              type: 'pie',
              radius: ['25%', '58%'],
              center: ["50%", "50%"],
              labelLine: {
                normal: {
                  lineStyle: {
                    color: '#34569D'
                  }
                }
              },
              label: {
                normal: {
                  formatter: '{d}%',
                  textStyle: {
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: 12
                  }
                }
              },
              data: syjgdata
            }, {
              itemStyle: {
                normal: {
                  color: '#13A7A2',
                }
              },
              type: 'pie',
              hoverAnimation: false,
              radius: ['35%', '65%'],
              center: ["50%", "50%"],
              label: {
                normal: {
                  show: false
                }
              },
              data: [{
                value: 1,
              }],
              z: -1
            }]
          });
        myChart2.setOption({
          legend: {
            textStyle: {
              color: '#ffffff'
            },
            bottom: -6
          },
          color: ["#7179CB"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
              label: {
                show: true
              }
            }
          },
          grid: {
            top: "25%",
            left: '11%',
            bottom: "15%"//也可设置left和right设置距离来控制图表的大小
          },
          dataset: {
            source: [
              ['product', '隐患个数'],
              ['一天', response.data.data.bigScreenHiddenDangerDelay.unprocessedOneDayCount],
              ['两天', response.data.data.bigScreenHiddenDangerDelay.unprocessedTowDayCount],
              ['三天', response.data.data.bigScreenHiddenDangerDelay.unprocessedThreeDayCount],
              ['四天', response.data.data.bigScreenHiddenDangerDelay.unprocessedFourDayCount],
              ['五天', response.data.data.bigScreenHiddenDangerDelay.unprocessedFiveDayCount],
              ['六天', response.data.data.bigScreenHiddenDangerDelay.unprocessedSixDayCount],
              ['七天', response.data.data.bigScreenHiddenDangerDelay.unprocessedSevenDayCount],
              ['七天以上', response.data.data.bigScreenHiddenDangerDelay.unprocessedMoreThanSevenDayCount],
            ]
          },
          xAxis: {
            type: 'category', axisLine: {
              show: false, //隐藏X轴轴线
              lineStyle: {
                color: '#01FCE3'
              }
            },
            axisTick: {
              show: false //隐藏X轴刻度
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ebf8ac" //X轴文字颜色
              },
              interval: 0, //坐标刻度之间的显示间隔，默认就可以了（默认是不重叠）
              rotate: 38   //调整数值改变倾斜的幅度（范围-90到90）
            },
          },
          yAxis: {
            splitLine: { show: false },
            axisLine: {
              lineStyle: {
                color: '#ccc'
              }
            }
          },
          // Declare several bar series, each will be mapped
          // to a column of dataset.source by default.
          series: [
            {
              barWidth: 15,
              type: 'bar', itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: "#00FFE3"
                  },
                  {
                    offset: 1,
                    color: "#4693EC"
                  }
                  ]),
                  label: {
                    show: true, //开启显示
                    position: 'top', //在上方显示
                    textStyle: { //数值样式
                      color: '#fff',
                      fontSize: 12
                    }
                  }
                }
              },
            },
          ]
          // xAxis: {
          //   type: 'category',
          //   data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          // },
          // yAxis: {
          //   type: 'value'
          // },
          // series: [{
          //   data: [response.data.data.bigScreenHiddenDangerDelay.unprocessedOneDayCount, 200, 150, 80, 70, 110, 130],
          //   type: 'bar'
          // }]
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hiddenDanger {
  width: 22.27%;
  height: 300px;
  margin-left: 1%;
  margin-top: 1.6%;
}
.pig div:nth-child(1) {
  color: white;
  padding-top: 10px;
  padding-bottom: 23px;
  margin-left: 93px;
  background-image: -webkit-linear-gradient(top, #e8ffff, #6fdfe9);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 24px;
  font-family: Hiragino Sans GB;
  font-weight: 900;
}
.danger_footer {
  width: 100%;
  background: url(../assets/delayHiddenDanger.png) no-repeat;
  background-size: 100% 100%;
  height: 435px;
  margin-top: 9%;
  padding-left: 4%;
}
</style>


// WEBPACK FOOTER //
// src/components/hiddenDanger.vue